module.exports = __webpack_public_path__ + "img/hot_air.85ac1755.jpg";